import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import useScreenSize from './shared/hooks/useScreenSize/useScreenSize';
import Navbar from "./navbar/Navbar";
import Home from "./home/Home";
import Footer from "./footer/Footer";
import Loading from './shared/Loading/Loading';
import './styles.css';

const About = lazy(() => import('./about/About'));
const Catalog = lazy(() => import('./catalog/Catalog'));
const Privacy = lazy(() => import('./privacy/Privacy'));
const Terms = lazy(() => import('./terms/Terms'));
const Faqs = lazy(() => import('./faq/Faq'));
const Contact = lazy(() => import('./contact/Contact'));
const NotFound = lazy(() => import('./notfound/NotFound'));


const App = () => {
  const screenSize = useScreenSize();
  const isMobile = screenSize.width < 769;

  return (
    <div id='app_container'>
      <Suspense fallback={<Loading />}>
        <Navbar isMobile={isMobile} />
        <Routes>
          <Route index element={<Home isMobile={isMobile} />} />
          <Route path='catalog' element={<Catalog isMobile={isMobile} />} />
          <Route path='about' element={<About isMobile={isMobile} />} />
          <Route path='privacy_policy' element={<Privacy isMobile={isMobile} />} />
          <Route path='terms_of_use' element={<Terms isMobile={isMobile} />} />
          <Route path='faqs' element={<Faqs isMobile={isMobile} />} />
          <Route path='contact' element={<Contact isMobile={isMobile} />} />
          <Route path='*' element={<NotFound isMobile={isMobile} />} />
        </Routes>
        <Footer isMobile={isMobile} />
      </Suspense>
    </div>
  );
};

export default App;
